import React from "react";

import GameTraverse from "../../Game/Traverse";

import "./InfoPane.scss";

type InfoPaneProps = {
  className?: string;
  imgSrc: string;
  imgAlt: string;
  title: string;
  subtitle?: string;
  bodyRender: () => JSX.Element;
  showButtons?: boolean;
};

function InfoPane({
  className = "",
  imgSrc,
  imgAlt,
  title,
  subtitle,
  bodyRender,
  showButtons = true,
}: InfoPaneProps) {
  return (
    <div className={`info-pane ${className}`}>
      <div className="img-pane">
        <img src={imgSrc} alt={imgAlt} />
      </div>
      <div className="body-pane">
        <header>
          <h1>{title}</h1>
          {subtitle && <h2>{subtitle}</h2>}
        </header>

        <div className="body">{bodyRender()}</div>
      </div>

      {showButtons && <GameTraverse />}
    </div>
  );
}

export default InfoPane;
